import * as Icons from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface IconProps extends Omit<LucideProps, 'size'> {
  name: keyof typeof Icons;
  size?: number;
  className?: string;
}

export default function Icon({ name, size = 20, className, ...props }: IconProps) {
  const LucideIcon = (Icons[name] ?? Icons.Circle) as React.ComponentType<LucideProps>;
  return (
    <LucideIcon
      size={size}
      className={cn('text-current', className)}
      {...props}
    />
  );
}
